import api from './api';

export interface SystemInventory {
  _id: string;
  name: string;
  acronym?: string;
  systemType: 'Application' | 'Database' | 'Platform' | 'Infrastructure' | 'Service' | 'Other';
  description?: string;
  owner?: string;
  status: 'Active' | 'Inactive' | 'Deprecated' | 'Planned';
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateSystemInventory {
  name: string;
  acronym?: string;
  systemType: 'Application' | 'Database' | 'Platform' | 'Infrastructure' | 'Service' | 'Other';
  description?: string;
  owner?: string;
  status?: 'Active' | 'Inactive' | 'Deprecated' | 'Planned';
  order?: number;
  isActive?: boolean;
}

export interface UpdateSystemInventory extends Partial<CreateSystemInventory> {}

const base = '/system-inventory';

const systemInventoryService = {
  async list(q?: string): Promise<SystemInventory[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as SystemInventory[];
  },
  async create(payload: CreateSystemInventory): Promise<SystemInventory> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as SystemInventory;
  },
  async update(id: string, payload: UpdateSystemInventory): Promise<SystemInventory> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as SystemInventory;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default systemInventoryService;
